import { Popover } from "flowbite-react";
import { FaInfoCircle } from "react-icons/fa";

type CardMgiProps = {
  value?: number;
};

const CardMgi = (props: CardMgiProps) => (
  <div
    className={`relative bg-white border border-gray5 shadow-md rounded-2xl p-5 transition hover:shadow-lg hover:scale-[1.01] animate-pulse font-semibold`}
    id="card-mgi"
  >
    <div className="grid grid-cols-[1fr_auto] gap-4 items-center justify-center">
      <div className="flex flex-col justify-center  items-center">
        <div className="mb-2 flex items-center gap-2">
          <h3 className={`text-xl font-semibold`}>
            M.G.I
          </h3>
          <Popover
            content={
              <div className="text-black border border-gray-300 rounded-md shadow-md p-2 max-w-sm relative z-40">
                <span className="text-sm">{`Moto Gap Index`}</span>
              </div>
            }
            placement="top"
            trigger="click"
          >
            <div className="cursor-pointer text-black" role="button-operational-management-group">
              <FaInfoCircle className="text-black" />
            </div>
          </Popover>
        </div>
        <p className={`text-3xl font-semibold`}>
          {(props.value ?? 0).toFixed(2).replace(".", ",")}
        </p>
      </div>
    </div>
  </div>
);

export default CardMgi;
